(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["soa-product-count"] && !Shopify.designMode) return;
  try {
    function formatCatalogCounts() {
    const params = new URLSearchParams(location.search);
    const filtered = [...params.keys()].some(key => key.startsWith('filter.') || key === 'constraint' || key === 'q');
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'tr');
    document.querySelectorAll('[data-catalog-count]').forEach(element => {
      let count = Number(element.dataset.catalogCount);
      let lowerBound = element.dataset.countLowerBound === 'true';
      if (filtered && element.dataset.countSource === 'snapshot') {
        count = Number(element.dataset.countFallback);
        lowerBound = count >= 25001;
        if (lowerBound) count = 25000;
      }
      if (Number.isSafeInteger(count) && count >= 0) {
        element.textContent = formatter.format(count) + (lowerBound ? '+' : '');
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', formatCatalogCounts, { once: true });
  } else {
    formatCatalogCounts();
  }
  document.addEventListener('shopify:section:load', formatCatalogCounts);
  } catch(e) { console.error(e); }
})();

})();
